import { axiosClient } from "./apiClient";

export async function getS3Config(data) {
    return axiosClient.post('authpanel/getconfigs', data);
}
export async function login(data) {
    return axiosClient.post('authpanel/login', data);
}
export async function countryList(data) {
    return axiosClient.get('authpanel/country_list', data);
}
export async function getAppContent(data) {
    return axiosClient.post('authpanel/getappcontent', data);
}
export async function getAppFAQs(data) {
    return axiosClient.post('authpanel/getfaq', data);
}
export async function getProfile(data) {
    return axiosClient.post('authpanel/getprofile', data);
}
export async function logout(data) {
    return axiosClient.post('/authpanel/logout', data);
}
export async function getProfileImageUploadUrl(data) {
    return axiosClient.post('/authpanel/getprofileimageuploadurl', data);
}
export async function getChartSession(data) {
    return axiosClient.post('/authpanel/getchartsession', data);
}
export async function getCountryList(data) {
    return axiosClient.post('/authpanel/countrylist', data);
}
export async function editProfile(data) {
    return axiosClient.post('/authpanel/editprofile', data);
}
export async function getDashboardCounts(data) {
    return axiosClient.post('/authpanel/dashboardcounts', data);
}
export async function getUsersListing(data) {
    return axiosClient.post('/authpanel/userlisting', data);
}
export async function inactiveUsers(data) {
    return axiosClient.post('/authpanel/inactiveusers', data);
}
export async function deleteAccount(data) {
    return axiosClient.post('/authpanel/deleteaccount', data);
}
export async function getDepositWithdrawals(data) {
    return axiosClient.post('/authpanel/getdepositwithdrawals', data);
}
export async function getDepositWithdrawalsDetails(data) {
    return axiosClient.post('/authpanel/getdepositwithdrawalsdetails', data);
}
export async function notificationsListing(data) {
    return axiosClient.post('/authpanel/notificationslisting', data);
}
export async function deleteNotification(data) {
    return axiosClient.post('/authpanel/deletenotification', data);
}
export async function customersListing(data) {
    return axiosClient.post('/authpanel/customerlisting', data);
}
export async function addNotifications(data) {
    return axiosClient.post('/authpanel/addnotifications', data);
}
export async function getOrdersListing(data) {
    return axiosClient.post('/authpanel/getorderslisting', data);
}
export async function getOrderDetails(data) {
    return axiosClient.post('/authpanel/getorderdetails', data);
}
export async function getAccountMetrics(data) {
    return axiosClient.post('/authpanel/getaccountmetrics', data);
}
export async function topFundedAccounts(data) {
    return axiosClient.post('/authpanel/topfundedaccounts', data);
}
export async function topTradingStocks(data) {
    return axiosClient.post('/authpanel/toptradingstocks', data);
}
export async function getEarningsListing(data) {
    return axiosClient.post('/authpanel/getearninglisting', data);
}
export async function getContactListing(data) {
    return axiosClient.post('/authpanel/getcontactlisting', data);
}
export async function getContactDetails(data) {
    return axiosClient.post('/authpanel/getcontactdetails', data);
}
export async function replyContactUs(data) {
    return axiosClient.post('/authpanel/replycontactus', data);
}
export async function deleteContactUs(data) {
    return axiosClient.post('/authpanel/deletecontactus', data);
}
export async function getUserDetails(data) {
    return axiosClient.post('/authpanel/getuserdetails', data);
}
export async function getFaqsListing(data) {
    return axiosClient.post('/authpanel/faqlisting', data);
}
export async function inactiveFaqs(data) {
    return axiosClient.post('/authpanel/inactivefaq', data);
}
export async function deleteFaq(data) {
    return axiosClient.post('/authpanel/deletefaq', data);
}
export async function addFaq(data) {
    return axiosClient.post('/authpanel/addfaq', data);
}
export async function getFaqDetails(data) {
    return axiosClient.post('/authpanel/getfaqdetails', data);
}
export async function editFaq(data) {
    return axiosClient.post('/authpanel/editfaq', data);
}
export async function saveAppContent(data) {
    return axiosClient.post('authpanel/saveappcontent', data);
}
export async function getUsersList(data) {
    return axiosClient.post('authpanel/getuserslisting', data);
}